import CustomerDetailsForm from "../forms/CustomerDetailsForm";
import {useDispatch} from "react-redux";
import {setCustomerDetails} from "../store/mainSlice";
import {useNavigate} from "react-router-dom";
import {Routes} from "../utils";


export default function CustomerScreen(props) {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const handleSubmit = data => {
    dispatch(setCustomerDetails(data))
    navigate(Routes.summary)
  }

  return (
    <div className="container" style={{maxWidth: 600}}>


      <CustomerDetailsForm onSubmit={handleSubmit}/>

    </div>
  )
}
